import { createAxiosInstance } from '../utils/axios.js'

const api = createAxiosInstance()

export const donationService = {
  async createDonationPaymentIntent (
    amount,
    donorName = null,
    donorEmail = null,
    note = null
  ) {
    try {
      const response = await api.post('/api/donations', {
        amount,
        donor_name: donorName,
        donor_email: donorEmail,
        note: note
      })
      return response.data
    } catch (error) {
      console.error('Failed to create donation payment intent:', error)
      throw error
    }
  },

  async createDonationCheckout (
    amount,
    paymentMethod,
    donorName = null,
    donorEmail = null,
    note = null
  ) {
    try {
      const response = await api.post('/api/donations/checkout', {
        amount,
        payment_method: paymentMethod,
        donor_name: donorName,
        donor_email: donorEmail,
        note: note
      })
      return response.data
    } catch (error) {
      console.error('Failed to create donation checkout:', error)
      throw error
    }
  },

  async getDonationDetails (donationId, donorEmail) {
    try {
      // Public endpoint requires email verification
      // Pass email as query parameter to verify the donor
      const response = await api.get(`/api/donations/${donationId}`, {
        params: { email: donorEmail }
      })
      return response.data
    } catch (error) {
      console.error('Failed to fetch donation details:', error)
      throw error
    }
  }
}
